import ElasticProcessor from '@lib/processors/elastic-processor'

const TABLE_FILTERS = [
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'externalId',
    label: 'External ID',
    type: 'string',
    icon: 'el-icon-notebook-2',
  },
  {
    attribute: 'customerName',
    label: 'Customer Name',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'billingAddress.streetAddress',
    label: 'Billing Address',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'shippingAddress.streetAddress',
    label: 'Shipping Address',
    type: 'string',
    icon: 'el-icon-box',
  },
  {
    attribute: 'updatedAt',
    label: 'Last Updated',
    type: 'date',
    icon: 'el-icon-date',
  },
]

const TABLE_COLUMNS = [
  {
    name: 'createdAt',
    label: 'Date Created',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 150,
  },
  {
    name: 'externalId',
    label: 'External ID',
    icon: 'el-icon-notebook-2',
    elasticSubField: 'lowercase',
    width: 150,
  },
  {
    name: 'customerName',
    icon: 'el-icon-box',
    elasticSubField: 'lowercase',
    width: 150,
  },
  {
    name: 'billingAddress.streetAddress',
    label: 'Billing Address',
    icon: 'el-icon-box',
    elasticSubField: 'lowercase',
    width: 300,
    format: (_, row) => {
      const addr = row.billingAddress

      return `${addr.streetAddress}, ${addr.suburb}, ${addr.state.toUpperCase()}, ${addr.postcode}`
    },
  },
  {
    name: 'shippingAddress.streetAddress',
    label: 'Shipping Address',
    icon: 'el-icon-box',
    elasticSubField: 'lowercase',
    width: 300,
    format: (_, row) => {
      const addr = row.shippingAddress

      return `${addr.streetAddress}, ${addr.suburb}, ${addr.state.toUpperCase()}, ${addr.postcode}`
    },
  },
  {
    name: 'updatedAt',
    label: 'Last Updated',
    format: 'dateTime',
    icon: 'el-icon-date',
    width: 150,
  },
]

export default component => ({
  processor: new ElasticProcessor({
    component,
    index: 'orders',
    initialDataQuery: {
      defaultSort: {
        createdAt: 'desc',
      },
    },
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'orders',
})
